var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "zhaopin-share-list" }, [
    _c(
      "ul",
      { staticClass: "list" },
      _vm._l(_vm.list, function (item, index) {
        return _c("li", { key: index, staticClass: "item" }, [
          _c("img", { attrs: { src: item.pic_path } }),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(item.name))]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(item.add_time))]),
        ])
      }),
      0
    ),
    _vm._v(" "),
    _vm.list.length == 0
      ? _c("div", { staticClass: "list-null" }, [_vm._v(" 暂无数据 ")])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }